/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StateTown } from './StateTown';
import {
    StateTownFromJSON,
    StateTownFromJSONTyped,
    StateTownToJSON,
} from './StateTown';

/**
 * 
 * @export
 * @interface FindAllStateTownsResponse
 */
export interface FindAllStateTownsResponse {
    /**
     * 
     * @type {Array<StateTown>}
     * @memberof FindAllStateTownsResponse
     */
    data: Array<StateTown>;
    /**
     * 
     * @type {number}
     * @memberof FindAllStateTownsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllStateTownsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllStateTownsResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllStateTownsResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllStateTownsResponse interface.
 */
export function instanceOfFindAllStateTownsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllStateTownsResponseFromJSON(json: any): FindAllStateTownsResponse {
    return FindAllStateTownsResponseFromJSONTyped(json, false);
}

export function FindAllStateTownsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllStateTownsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(StateTownFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllStateTownsResponseToJSON(value?: FindAllStateTownsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(StateTownToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

